export default {
    "layout_chi_siamo": "About us",
    "layout_orari": "Opening hours",
    "layout_info": "Info",
    "layout_news": "News",
    "layout_indirizzi_consegna": "Delivery addresses",
    "layout_notifiche": "Notifications",
    "layout_impostazioni": "Settings",
    "layout_login": "Login",
    "layout_logout": "Logout",
    "layout_privacy": "Privacy policy",
    "layout_fidelity_card": "Fidelity card",
    "layout_prenota_tooltip": "Book a table",
    "layout_carrello_tooltip": "Cart",
    "layout_profilo_tooltip": "Account",
    "layout_domanda_titolo": "When would you like to eat?",
    "layout_opzioni_label": "Order options",
    "layout_opzioni_label_csconto_tooltip": "Discount codes",
    "impostazioni_lingue": "Languages",
    "impostazioni_notifiche": "Push notifications",
    "impostazioni_ordini": "Orders and reservations",
    "impostazioni_ordini_txt": "Notifications about the status of orders and reservations",
    "impostazioni_sconto": "News and discount codes",
    "impostazioni_sconto_txt": "Notifications about news and discount codes",
    "impostazioni_suggerimenti": "Activities and suggestions",
    "impostazioni_suggerimenti_txt": "Personalised notifications based on your activities",
    "impostazioni_sempre": "always",
    "impostazioni_attive": "active",
    "impostazioni_login_required": "Log in to manage notifications.",
    "impostazioni_si": "Yes",
    "impostazioni_no": "No",
    "notifiche_valido_tutti_locali": "Valid at all locations",
    "notifiche_valido_locali": "Valid at locations:",
    "index_ordine_titolo": "where would you like to order?",
    "ristorante_benvenuto": "welcome on",
    "ristorante_consulta": "Have a look at the menu and place your order",
    "ristorante_prenota": "Book a table at the restaurant",
    "ristorante_sondaggio": "Survey",
    "ristorante_ordina_btn": "order now",
    "ristorante_prenota_btn": "book now",
    "ristorante_presentiamo_titolo": "about us",
    "ristorante_continua_lettura_btn": "keep reading",
    "ristorante_novita_titolo": "latest news",
    "ristorante_novita-vedi_btn": "see all the news",
    "ristorante_orario_titolo": "opening times",
    "ristorante_chiusure_title": "Next closures",
    "ristorante_contatti_titolo": "contact us",
    "ristorante_dettaglio_titolo": "about us...",
    "confermato": "Confirmed",
    "rifiutato": "Refused",
    "attesa": "Hold",
    "annullato": "Canceled",
    "ordine_appena_possibile": "As soon as possible",
    "ordine_n_persone": "Choose the number of people",
    "ordine_titolo": "Order online",
    "ordine_scelta_titolo": "choose a type",
    "ordine_scelta_data_titolo": "choose a date",
    "ordine_scelta_orario_titolo": "choose a time",
    "ordine_menu_btn": "See the menu",
    "ordine_salva_ordine_btn": "add to order",
    "ordine_dettaglio": "order details",
    "ordine_numero": "Order Nr.",
    "ordine_annulla_msg": "To cancel or change the booking we invite you to contact directly the premises through their telephone number.",
    "ordine_torna_storico": "Back to history",
    "ordine_tempo_esaurito_label": "The time at your disposal to complete the order has run out.<br>\n        \t\t\t\t\t\t\t  Choose a new time span.",
    "ordine_posti_esauriti_label": "There aren't places for the selected time span.",
    "ordine_scegli_orario_label": "choose a time",
    "ordine_opzioni": "order options",
    "ordine_inviato": "Your order has been<br>successfully sent",
    "ordine_riepilogo": "order summary",
    "ordine_consegna_id": "Delivery at",
    "ordine_fatturare_a": "Invoice to",
    "ordine_consegna": "Delivery",
    "ordine_sconto": "Discount code",
    "ordine_sconto_errato": "Wrong code",
    "ordine_sconto_invalido": "Code not valid for this premises",
    "ordine_sconto_applicato": "Discount",
    "ordine_storico": "Orders history",
    "ordini_effettuati": "orders made",
    "ordini_pagamento": "Payment",
    "ordini_riepilogo_label": "Order confirmation",
    "ordini_ordine": "Order",
    "ordini_data": "placed on",
    "ordini_ritiro_label": "Collect at our premises on",
    "ordini_ore": "at",
    "ordini_consegna_giorno": "Delivery scheduled on",
    "ordini_consegna_fascia": "in the time span",
    "ordini_consegna_indirizzo": "At the following address",
    "ordini_fatturare_nome": "Invoice to",
    "ordini_note": "Order notes",
    "ordini_totale": "Order total",
    "ordine_riepilogativa": "This e-mail summarises the order you just made",
    "ordine_dettagli": "To know all the order details go to the &quot;Order history&quot; app section",
    "ordine_dettagli_ridotto": "To know all the order details go to the &quot;Order history&quot; app section",
    "ordine_clicca_dettagli": "or click on the &quot;Order details&quot; one below.",
    "ordine_dettagli_label": "Order details",
    "ordine.prezzo_minimo_no": "To proceed, the amount must be at least ",
    "ordine.ingredienti": "Ingredients",
    "ordine.allergeni": "Allergens",
    "ordine.aggiunte": "Additions",
    "ordine.nessuna_aggiunta_disponibile": "No addition available",
    "ordine.bloccati_msg": "temporarily suspended",
    "ordine.seleziona_aggiunte": "Select the additions you prefer",
    "ordine.dettagli_allergeni": "Allergens details",
    "ordine.allergeni_contenuti_label": "Allergens contained or that can be found are",
    "ordine.allergeni_informazioni_text": "These information refer to the 14 main allergens identified by the existing regulation (save from ingredients excluded from the regulation). Such list is base on the data submitted by our suppliers, which relate to their products' composition for the ingredients voluntarily added. Nonetheless, we cannot entirely exclude the fortuitous presence of other allergenic ingredients that may be found in the production of this food products from our suppliers or due to their in use in the restaurant.\n        \t\t\t\t\t\t\t\t\t The products composition might be subject to changes. We will make our best efforts to update this section, especially when we will be informed of the change of the composition of one of them. We invite you to visit this section regularly and to submit the various items of this section to your physician or allergist in order be advised about the food choice.",
    "ordine.grazie_ok": "thanks, I understand",
    "ordine.leggenda_informazioni": "Information",
    "ordine.misura": "Size",
    "ordine.misura_sel": "Choose a size",
    "ordine.variante_titolo": "Variant",
    "ordine.variante_sel": "Choose a variant",
    "ordine.scegli": "You have to choose products for a minimum amount of",
    "carrello_importo_indicativo": "This is the approximate amount. The real amount shall be applied once you enter or confirm the delivery address.",
    "carrello_tempo_disponibile": "After clicking on \"Proceed\", you will have 15 minutes to complete the order and book the date and time selected.",
    "carrello_avviso_spese_consegna": "Delivery expenses shall be calculated by proceeding with the order.",
    "carrello_ordine_label": "order",
    "carrello_indirizzo_consegna": "Delivery address",
    "carrello_predefinito": "Preset address",
    "carrello_mod_pagamento": "Payment method",
    "prenota_mod_pagamento": "Select payment method",
    "carrello_mezzo_pagamento": "How will you pay on collection\/delivery?",
    "carrello_pag_contanti_ritiro": "Upon collection",
    "carrello_pag_contanti_consegna": "Upon delivery",
    "carrello_pag_buoni_pasto": "Food voucher",
    "carrello_pag_carte": "Credit card",
    "carta_di_credito_consegna": "By debit/credit card on delivery",
    "carta_di_credito_ritiro": "By debit/credit card on takeaway",
    "carrello_pag_bancomat": "Bancomat",
    "carrello_richiedi_fattura": "Invoice request",
    "carrello_riepilogo": "Cart summary",
    "carrello_sconto": "Use a discount",
    "carrello_premio": "Use a reward",
    "carrello_ins_sconto": "ENTER THE DISCOUNT CODE HERE:",
    "carrello_appl_sconto": "apply code",
    "carrello_appl_sconto_dett": "The discount is applicable to products only. It does not include delivery fees.",
    "carrello_note_generali": "Order notes",
    "carrello_ord_del": "delete order",
    "carrello_ord_conf": "confirm order",
    "carrello_vai_pagamento": "GO TO PAYMENT",
    "carrello_completa_ordine": "COMPLETE ORDER",
    "carrello_sel_ind_title": "Choose an address",
    "carrello_sel_ind_label": "Choose a delivery address",
    "carrello_ind_predefinito": "Use as preset address",
    "carrello_no_ind_consegna": "NO DELIVERY ADDRESS SET",
    "carrello.messaggio_alert_indirizzo": "NO DELIVERY ADDRESS CHOSEN",
    "carrello.messaggio_alert_fattura": "NO INVOICING ADDRESS CHOSEN",
    "carrello.indicazione_fattura": "Enter an invoicing address clicking on the icon on the side",
    "carrello.prd_aggiunto": "Product added to the cart.",
    "carrello.ingrediente_esaurito": "The ingredient:",
    "carrello.ingrediente_esaurito2": "for this product is temporarily not available. You can still order it and specify an addition if you wish.",
    "carrello.sconto_ordine_min_mag": "The minimum order to use the discount is",
    "carrello.escluse_spese_spedizione": "escluse le spese di spedizione",
    "carrello.codice_sconto_usato": "The discount code has already been used for the maximum number of times allowed.",
    "carrello.quantita": "Quantity",
    "carrello.prd_non_disponibili_msg": "Warning: some products maybe not available in the newly selected time span. They will be removed from the cart",
    "carrello.scadenza_carrello": "Cart expiration",
    "carrello.scadenza_minuti": "minutes",
    "carrello.rimangono_min": "You have",
    "carrello.disponibilita_non_garantita": "left to complete the order,<br>after which we cannot guarantee<br>you the availability for the selected date and time.",
    "account.dati_utente": "User data",
    "account.gestione_indirizzi": "Address book management",
    "account.gestione_indirizzi_fatt": "Invoicing address",
    "account.storico_ordini": "Orders history",
    "account.prenotazioni": "Bookings",
    "account.dati_registrazione": "registration data",
    "account.termini_condizioni": "Terms and Conditions",
    "account.nuovo_indirizzo_consegna": "New delivery address",
    "account.campanello": "Doorbell",
    "account.indirizzo_fatturazione": "Invoicing address",
    "account.mod_indirizzo_fatturazione": "Change invoicing address",
    "account.accedi_dati": "log in with your details",
    "account.nome_utente": "User name",
    "account.password.dimenticata": "Forgot password",
    "account.accedi": "log in",
    "account.usr_no_mod": "For safety reasons, you cannot change your username.",
    "account.no_registrato": "aren't you registered",
    'account.prosegui_ospite': 'continue as a guest',
    "account.registrazione": "Registration",
    "account.dati_account": "account data",
    "account.conf_password": "Repeat password",
    "account.msg_conf_password_err": "Password and Confirm password must match.",
    "account.inserire_indirizzo_domanda": "would you like to enter a delivery address",
    "account.via": "Street",
    "account.civico": "Street Nr.",
    "account.sel_city": "Choose a city",
    "account.sel_country": "Choose a country",
    "account.sel_cap": "Choose a post code",
    "account.inserire_ind_fat_domanda": "do you want to enter an invoicing address",
    "account.reg_soc": "Business name",
    "account.citta": "City",
    "account.prv": "Province",
    "account.cap": "Zip",
    "account.stato": "Country",
    "account.acc_termini": "Terms and Conditions acceptance",
    "account.registrarti": "sign up",
    "account.registrazione_ok": "Registration successfully made",
    "account.save_ok": "Change successfully implemented",
    "account.effettua_login": "Log in",
    "account.recupera_password": "retrieve password",
    "account.mail_recupera_inviata": "Request successfully sent",
    "account.ins_utente_rec_password": "Enter your account to retrieve your password",
    "account.recupera_btn": "Retrive",
    "account.recupera_controlla_mail": "Check your e-mail inbox, and also your spam folder: we have sent you the credentials to access the service.",
    "account.mail.recupera_psw.uno": "Dear",
    "account.mail.recupera_psw.due": "click on the following link to set a new password for your account ",
    "account.mail.recupera_psw.tre": "The staff of",
    "account.nuova_password_ind": "Enter the new password",
    "account.nuova_password_label": "Set a new password",
    "account.account_non_trovato": "Account not found",
    "account.campo_obbligatorio": "is a mandatory field",
    "account.psw_coincidenti": "Password and Confirm password must match",
    "account.termini_condizioni_msg": "In order to proceed, you must you must accept our Terms & Conditions",
    "account.acc_privacy_msg": "In order to proceed, you must accept our privacy policy",
    "account.cntr_spam_msg": "Check your e-mail inbox, and also your spam folder: we have sent you the credentials to access the service",
    "account.cliente_non_trovato": "User not found",
    "account.apikey_non_trovata": "Api Key not found",
    "account.indirizzo_non_trovato": "Address not found",
    "account.account": "Account",
    "account.delete_title": "Delete account",
    "account.delete_warning": "You are about to delete your user account.",
    "account.delete_description": "By proceeding, your data will be deleted and will not be recoverable. If you want to place a new order or use the app in the future, you will need to register again.",
    "account.delete_confirm": "Delete account",
    "prenotazione.storico": "bookings history",
    "prenotazione.effettuate": "bookings made",
    "prenotazione.dettagli": "booking details",
    "prenotazione": "Reservation",
    "prenotazione.status": "Status",
    "prenotazione.riferimento": "Reference",
    "prenotazione.annulla": "cancel booking",
    "prenotazione.info_annulla": "In order to cancel or change the booking, we invite you to get in touch directly with the restaurant through their phone number",
    "prenotazione_tavolo.richiesta": "table booking request",
    "prenotazione_tavolo.tavolo_per": "book a table",
    "prenotazione_tavolo.dati": "personal details",
    "prenotazione_tavolo.privacy": "Privacy Policy acceptance",
    "prenotazione_tavolo.privacy.informativa": "Read the Policy",
    "prenotazione_tavolo.submit_btn": "Book a table",
    "prenotazione_tavolo.richiesta_inviata": "The booking request has been sent.",
    "prenotazione_tavolo.richiesta_confermata": "The booking request has been confirmed.",
    "prenotazione_tavolo.attendi_conferma": "Wait for a confirmation by our staff!",
    "prenotazione_tavolo.ti_aspettiamo": "We are waiting for you!",
    "prenotazione_tavolo.augurio": "Have a good time",
    "prenotazione_tavolo.torna_home": "Back to home",
    "prenotazione_tavolo.precedente": "previous",
    "prenotazione_tavolo.successivo": "next",
    "prenotazione_tavolo.torna_lista": "Back to list",
    "prenotazioni_tavolo.bloccate": "Reservations temporarily suspended",
    "prenotazioni_tavolo.nessuna": "No reservations made",
    "prenotazioni_tavolo.persona": "person | people",
    "prenotazioni_tavolo.persone": "people",
    "allergeni.glutine": "Gluten",
    "allergeni.crostacei": "Crustaceans",
    "allergeni.uova": "Egg",
    "allergeni.pesce": "Fish",
    "allergeni.arachidi": "Peanuts",
    "allergeni.soia": "Soy",
    "allergeni.latte": "Milk",
    "allergeni.fruttasecca": "Dried fruit",
    "allergeni.sedano": "Celery",
    "allergeni.senape": "Mustard",
    "allergeni.sesamo": "Sesame",
    "allergeni.molluschi": "Clams",
    "allergeni.cereali": "Cereals",
    "allergeni.so2": "Sulfur dioxide",
    "news.rimani_aggiornato": "keep yourself updated",
    "news.lista": "news summary",
    "news.leggi": "Read",
    "sconti.lista_title": "active discount codes",
    "sconti.ordine_minimo": "Minimum order",
    "termini_condizioni.titolo": "Terms and conditions",
    "termini_condizioni.testo": "KUOKKO ti da il benvenuto!<br>\n        Siamo davvero entusiasti che tu abbia deciso di accedere ed utilizzare i Servizi costituiti dalla nostra piattaforma per gli ordini online, a cui si accede tramite il sito web e le applicazioni KUOKKO per conto dei nostri clienti Ristoranti.<br><br>\n        I presenti Termini e Condizioni d\u2019Uso costituiscono l'accordo tra te (Utente), il Ristorante indicato nei Servizi ed Agaweb srl Unipersonale (Agaweb) societ\u00e0 proprietaria, gestore ed erogatore del Servizio KUOKKO. Disciplinano l'utilizzo dell\u2019applicazione mobile, della web app, dei relativi software e servizi, prenotazioni dei tavoli, commercio a distanza, promozioni e notifiche push (di seguito \u201cServizi\u201d). Prima di utilizzare i Servizi ti invitiamo a leggere i Termini e Condizioni d\u2019Uso ed ad accettarli solo ove compresi e condivisi.<br><br>\n        \n        <b>Utente e responsabilit\u00e0<\/b><br>\n        Per Utente si intende la persona fisica che utilizza i Servizi per scopi personali che ha compiuto la maggiore et\u00e0 e che possiede la capacit\u00e0 di agire (conformemente all\u2019art. 2 del codice civile italiano). L\u2019Utente \u00e8 responsabile per gli ordini, le prenotazioni e le altre azioni effettuate attraverso i Servizi. Le eventuali offerte sulle bevande alcoliche sono riservate esclusivamente agli Utenti maggiorenni. Ogni utente \u00e8 responsabile degli alimenti ordinati e consumati, con particolare riferimento ad eventuali intolleranze o allergie. <br><br>\n        \n        <b>Ristorante<\/b><br>\n        Per Ristorante si intende l\u2019esercizio commerciale indicato nei Servizi presso il quale effettuare gli ordini take away o delivery, le prenotazioni dei tavoli e dal quale ricevere notifiche push e promozioni.<br><br>\n        \n        <b>Agaweb srl Unipersonale<\/b><br>\n        Agaweb srl Unipersonale \u00e8 la societ\u00e0 ideatrice, proprietaria e gestore dei Servizi KUOKKO nonch\u00e9 proprietaria del marchio Kuokko.<br><br>\n        \n        <b>Descrizione del servizio<\/b><br>\n        Kuokko \u00e8 una piattaforma di ultima generazione per gli ordini online che utilizza le pi\u00f9 recenti tecnologie web e mobile per consentirti di ordinare dal Ristorante e molto altro ancora.<br>\n        Kuokko non vende i prodotti contenuti nel tuo ordine, non \u00e8 parte di tali transazioni e non ha alcun controllo sulla qualit\u00e0 o sicurezza dei prodotti. Il tuo ordine \u00e8 tra te (Utente) e il Ristorante dal quale ordini. <br>\n        Il ristorante pu\u00f2 dichiarare gli ingredienti o rappresentare gli allergeni o gli standard di preparazione dei cibi attraverso i Servizi, come ad esempio cibo o bevande che non contengono noci, senza glutine, senza lattosio, biologici o altro. Non esaminiamo n\u00e9 verifichiamo i menu, gli ingredienti, gli standard di preparazione del cibo o eventuali descrizioni o dichiarazioni fatte dai ristoranti.<br> \n        Pertanto, se tu o chiunque consumi un pasto, ingrediente o un qualsiasi altro articolo ordinato tramite i Servizi, ha qualche allergia alimentare o requisiti specifici di preparazione, ti consigliamo vivamente di contattare direttamente il ristorante per soddisfare le tue specifiche esigenze. <br><br>\n        Utilizzando i Servizi, accetti che Kuokko non \u00e8 responsabile per dichiarazioni o omissioni relative ai prodotti contenuti nel tuo ordine. Forniamo ai visitatori e agli utenti registrati l'accesso ai servizi come descritto nel presente accordo.<br><br>\n        &bull; Visitatori. Nessun accesso \u00e8 richiesto per i visitatori dei Servizi. I visitatori possono (a) visualizzare tutti i contenuti accessibili al pubblico, (b) inviarci un'e-mail.<br><br>\n        &bull; Utenti registrati. Il login \u00e8 richiesto per tutti i servizi per utenti registrati. Gli utenti registrati possono fare tutto ci\u00f2 che i visitatori possono fare, e anche (a) effettuare ordini, (b) richiedere una prenotazione, (c) utilizzare codici sconto riservati, (d) ricevere avvisi e altre notifiche.<br><br>\n        Kuokko non ha alcun obbligo di accettare alcun individuo come Utente Registrato e pu\u00f2 accettare o rifiutare qualsiasi registrazione a sua sola e completa discrezione.<br><br>\n        \n        <b>Come effettuare un ordine take away, delivery o una prenotazione<\/b><br>\n        Se non effettui la registrazione, puoi visualizzare il menu senza concludere l\u2019ordine e inviare una richiesta di prenotazione inserendo manualmente i tuoi dati di contatto. Per effettuare un ordine take-away o delivery e gli altri Servizi per utenti registrati, \u00e8 necessario effettuare la registrazione. Le credenziali dovranno essere mantenute riservate ed ogni utente \u00e8 responsabile della riservatezza di tali dati. <br>\n        Per effettuare un ordine take away o delivery devi registrarti ed effettuare il log-in. Di seguito potrai scegliere il giorno e l\u2019ora in cui desideri usufruire del servizio e aggiungere i piatti al tuo carrello. Dopo avere completato la scelta del servizio e confermato l\u2019ordine,  quest\u2019ultimo verr\u00e0 processato per il completamento. Riceverai una e-mail o altro tipo di notifica che ti dar\u00e0 conferma del buon fine dell\u2019ordine e riepilogo.<br>\n        Per effettuare una prenotazione puoi effettuare il log-in per evitare di inserire i tuoi dati. Se non effettui il log-in dovrai inserire i tuoi dati manualmente. Di seguito potrai scegliere data, ora e numero di persone che desiderano usufruire del servizio. Riceverai una e-mail o altro tipo di notifica che ti dar\u00e0 conferma o meno del buon fine della prenotazione.<br><br>\n        \n        <b>Mancata esecuzione dell'ordine<\/b><br>\n        In tutti i casi in cui l\u2019ordine non venga processato nessuna responsabilit\u00e0 potr\u00e0 essere attribuita al Ristorante o ad Agaweb. In ogni caso l\u2019eventuale responsabilit\u00e0 del Ristorante \u00e8 da intendersi limitata entro il valore dell\u2019ordine.<br><br>\n        \n        <b>Cancellazione dell'ordine<\/b><br>\n        Per la cancellazione dell\u2019ordine \u00e8 necessario contattare il Ristorante e concordare direttamente le modalit\u00e0.<br><br>\n        \n        <b>Pagamenti<\/b><br>\n        L\u2019Utente pu\u00f2 pagare il proprio ordine o Servizio direttamente al ritiro in Ristorante o alla consegna. Pertanto il pagamento \u00e8 regolamentato direttamente con il Ristorante.<br><br> \n        \n        <b>Sconti e promozioni<\/b><br>\n        Gli eventuali sconti verranno effettuati dal Ristorante che potr\u00e0 crearli in base alle proprie esigenze. Lo sconto avr\u00e0 la durata e l\u2019importo o la percentuale che di volta in volta il Ristorante indicher\u00e0.<br><br>\n        \n        <b>Funzionamento dei Servizi<\/b><br>\n        I Sistemi vengono erogati attraverso gli store Apple e Google. Nessuna responsabilit\u00e0 potr\u00e0 essere attribuita al Ristorante o ad Agaweb in caso di sospensione, modifica o cessazione del servizio da parte di Apple o Google. Apple o Google e il Ristorante o Agaweb sono quattro soggetti giuridici distinti ed indipendenti. Il Ristorante e Agaweb non potranno essere ritenuti responsabili nei confronti dell'Utente per il cattivo funzionamento e\/o l\u2019interruzione dell\u2019operativit\u00e0 dei Servizi, anche per brevi periodi, dovuto ad inconvenienti tecnici hardware, dei software e\/o delle linee di trasmissione e di accesso alla rete o dovuti a caso fortuito, forza maggiore o fatto imputabile a terzi.<br><br>        \n        \n        <b>Efficacia delle condizioni d'uso<\/b><br>\n        Il Ristorante non garantisce che i contenuti dei Servizi siano appropriati o leciti in paesi differenti dall\u2019Italia. L\u2019eventuale invalidit\u00e0, nullit\u00e0 o inefficacia di uno o pi\u00f9 clausole delle presenti Condizioni D\u2019Uso non determiner\u00e0 l\u2019invalidit\u00e0, inefficacia o nullit\u00e0 delle restanti clausole che resteranno valide ed efficaci.<br><br>\n        \n        <b>Modifica delle condizioni d'uso<\/b><br>\n        Il Ristorante tramite Agaweb potr\u00e0 richiedere all\u2019Utente di accettare, di volta in volta, ulteriori condizioni applicabili a parti specifiche o sezioni dell\u2019APP. Tali condizioni ulteriori saranno immesse nelle parti dell\u2019APP a cui si riferiscono e saranno chiaramente identificabili. Il Ristorante tramite Agaweb potr\u00e0 modificare le Condizioni D\u2019Uso le quali saranno applicabili a seguito della pubblicazione online e accettate con l\u2019utilizzo dell\u2019APP.<br><br>\n        \n        <b>Lingua e legge applicabile<\/b><br>\n        La legge che disciplina le Condizioni D\u2019Uso \u00e8 la legge italiana. Il presente accordo \u00e8 stato redatto in lingua italiana.<br>\n        Qualsiasi controversia che dovesse derivare dal rapporto regolato dal presente accordo \u00e8 di competenza esclusiva della giurisdizione ordinaria italiana.<br>",
    "note_generali_label": "General notes",
    "btn_salva": "Save",
    "totale": "Total",
    "dettagli": "Details",
    "btn_annulla": "Cancel",
    "btn_conferma": "Confirm",
    "btn_applica": "Apply",
    "btn_modifica": "Edit",
    "btn_elimina": "Delete",
    "btn_indietro": "Back",
    "attenzione_label": "Warning",
    "nome": "Name",
    "cognome": "Surname",
    "email": "Email",
    "telefono": "Phone",
    "chiudi": "close",
    "sito_manutenzione": "Website under maintenance",
    "zona": "Area",
    "vai_alle": "or go to",
    "cod_fisc": "Fisc. Code",
    "piva": "VAT",
    "note": "Note",
    "prosegui": "continue",
    "carrello_vuoto": "CART EMPTY",
    "allergeni_contenuti": "The allergens contained or that could be found in your products:",
    "varianti": "variants",
    "gusto": "Choice",
    "gusti": "Choices",
    "agg_ingr": "add ingredients",
    "nessuna": "None",
    "scarica_app": "For a better experience and fluidity,<br>\n\t\t\t\t\twe invite you to download our app.<br>\n\t\t\t\t\tAvailable from AppStore and Google Play.<br>\n\t\t\t\t\tThank you!",
    "menu": "menu",
    "nessuna_variante": "No variant",
    "aggiungi": "add",
    "sconto": "Discount",
    "nessun_ordine": "No orders placed",
    "messaggio_locale": "Message from the restaurant",
    "chiuso": "Closed",
    "sempre_valido": "Always valid",
    "prenotazione_nuova": "News",
    "prenotazione_attesa": "Waiting",
    "prenotazione_annullata": "Canceled",
    "prenotazione_rifiutata": "Rejected",
    "prenotazione_confermata": "Confirmed",
    "carrello.codice_sconto_nonattivo": "Discount code not active",
    "ore": "at",
    "aggiunta": "Add",
    "qta": "qty",
    "select_order_type": "Select the type of order from those listed above to choose the date and see the menu.",
    "eat_at_restaurant": "pre-order",
    "al_tavolo": "at the table",
    "takeaway": "takeout",
    "delivery": "Delivery",
    "type_message_here": "Type your message here",
    "mangia_tavolo_label": "Eat a the table expected at",
    "contanti": "Cash",
    "precalculated_fidelity_points_1": "With this order you will accumulate",
    "precalculated_fidelity_points_2": "points. Points will be displayed on your loyalty card on the takeaway\/delivery date.",
    "address_management_changed": "Address management changed, you need to delete and recreate the address",
    "fidelity_card_ad_home_c1": "So far, you've been accumulating",
    "punti": "points",
    "dal": "from",
    "al": "to",
    "fidelity_card_accumulato": "You've accumulated",
    "raccogli": "Collect",
    "fidelity_card_raccogli_1": "Collect",
    "fidelity_card_raccogli_2": "points to get this reward",
    "fidelity_card_punti_regola_1_1": "The points are updated when the order is consumed (date / time of collection or delivery).",
    "fidelity_card_punti_regola_1_2": "Rewards are automatically accumulated upon reaching the required points threshold.",
    "fidelity_card_punti_regola_1_3": "The total score will be reset when the maximum points are reached.",
    "fidelity_card_punti_regola_1_4": "When using a reward in an order, it will be deleted from the reward list.",
    "fidelity_card_punti_regola_2_1": "The points are updated when the order is consumed (date / time of collection or delivery).",
    "fidelity_card_punti_regola_2_2": "Rewards can be chosen once the necessary points threshold has been reached.",
    "fidelity_card_punti_regola_2_3": "The score will not be reset, but will continue to grow with subsequent orders.",
    "fidelity_card_punti_regola_2_4": "When using a reward in an order, the reward score will be subtracted from the accumulated points total.",
    "fidelity_mask_locali_warning": "Attention: In this place ({NOME_LOCALE}) you cannot accumulate points and redeem prizes.",
    "fidelity_card_no_promozione": "No promotion going on",
    "fidelity_card_no_premi": "No rewards available",
    "valido_dal": "Valid from",
    "reward": "Reward",
    "fidelity_card_sconto_del_1": "",
    "fidelity_card_sconto_del_2": "% discount",
    "fidelity_card_usato_ordine": "Used in order No.",
    "fidelity_card_usato_ordine_del": "of",
    "fidelity_card_premi_utilizzati": "Used rewards",
    "fidelity_card_premi_accumulati": "Accumulated rewards",
    "fidelity_card_promozione_non_cumulabile": "Promotion not combinable with other promotions.",
    "fidelity_card_punti_non_si_azzerano": "The points are not reset at the end of the promotion, however the points may be incompatible with the activation of a new promotion, in which case they will be reset.",
    "fidelity_card_punti_azzerano_1": "Accumulated rewards will reset after",
    "fidelity_card_punti_azzerano_2": "days from the expiration of the promotion.",
    "messaggi": "Messages",
    "messaggistica": "Messaging",
    "messaggistica_conversazioni_attive": "Active conversations",
    "messaggistica_no_ordine_prenotazione": "No order or reservation suitable for messaging",
    "messaggeria": "Messaging",
    "messaggistica_nessun_messaggio_disponibile": "No messages available",
    "valido il": "Valid",
    "sconto_applicato": "Applied discount",
    "premio_applicato": "Applied reward",
    "indirizzo_non_modificabile": "Address no longer editable",
    "indirizzo_non_valido": "Address management changed, you need to delete and recreate the address",
    "sconto_problema_#1": "It is not possible to use a discount when a reward is active",
    "sconto_problema_#2": "Discount not available",
    "sconto_problema_#3": "Usage limit reached",
    "sconto_problema_#4": "The discount requires a minimum order of ",
    "rimuovi_sconto": "remove discount",
    "seleziona_acconto": "Select deposit",
    "usa_premio_ordine": "Use a reward in your order",
    "seleziona_premio": "Select the reward",
    "usa_premio": "Use reward",
    "premi_accumulati": "Accumulated rewards",
    "premio": "Reward",
    "rimuovi_premio": "Remove reward",
    "ore_in_data": "at",
    "consigliperte": "recommended for you",
    "prodotti_suggeriti": "suggested products",
    "password": "password",
    "confirm_remove_address": "Are you sure you want to delete this address?",
    "gratis": "Gratis",
    "limite_tempo_terminato": "The time limit for the conversation has expired",
    "down_payment": "Down payment",
    "impossible_confirm_payment": "Impossible to confirm the payment",
    "label_carta_credito": "Credit or debit card",
    "label_titolare_carta": "Card holder",
    "adds_not_availabe_with_config": "It is not possible to add ingredients to this product with the selected characteristics.",
    "max_scelte": "max {n} choice | max {n} choices",
    "aggiunte_gratis": "free first addition | free first {n} additions",
    "max_picks_reached_1": "The selected product allows a maximum of",
    "max_picks_reached_2": "tastes for",
    "max_picks_reached_3": "picks.",
    "max_picks_reached_4": "Maximum number of tastes reached.",
    "scegli": "Choose",
    "no_more_availability": "Product not available",
    "more_than_availability": "More than {n} available",
    "residual_availability": "Residual availability",
    "out_of_stock_single_begin": "The ingredient for this product",
    "out_of_stock_single_end": "is temporarily not available. You can still order it and specify an addition if you wish.",
    "out_of_stock_multiple_begin": "IngredientS for this product",
    "out_of_stock_multiple_end": "ARE temporarily not available. You can still order it and specify an addition if you wish.",
    "min_free_picks_alert": "You must choose at least {n} taste | You must choose at least {n} tastes",
    "cambio_locale_carrello_alert": "The cart will be emptied. Are you sure you want to proceed?",
    "spesa_min_indirizzo": "The minimum charge for the selected address is",
    "save_into_my_data": "Save in my data",
    "premio_problema_#1": "It is not possible to use a reward when a discount is active",
    "cannot_select_reward_1": "You cannot select the reward",
    "cannot_select_reward_2": "because you don't have a corresponding product in the cart",
    "continua_con_google": "Continue with Google",
    "continua_con_apple": "Continue with Apple",
    "scegli_come_ordinare": "Choose how to order",
    "scegli_zona": "Choose the area",
    "scegli_locale": "Choose the restaurant",
    "punto_consegna": "Delivery point",
    "messaggio_alert_punto_consegna": "It is necessary to enter the delivery point",
    "scegli_piatti": "Choose the dishes",
    "alert_combo_picks_min_prod": "At least one product must be entered | At least {n} products must be entered",
    "n_prodotti": "1 product | {n} products",
    "di_cui": "Including",
    "della_categoria": "of the {category} category",
    "necessario_un_prodotto": "At least one product must be entered",
    "soglia_minima_prodotto": "The minimum threshold for the product is",
    "prezzo_fisso": "Fixed price",
    "prezzo_minimo": "Minimum price",
    "nessuna_fascia_trovata": "No time slots found for this address",
    "min": "Min",
    "combo": "COMBO",
    "scegli_citta": "Choose city",
    "indirizzo": "Address",
    "numero": "Number",
    "seleziona_citta": "Select city",
    "removed_free_pick_alert_1": "For this product the choice | For this product the choices",
    "removed_add_alert_1": "For this product the addition | For this product the additions",
    "removed_add_free_pick_alert_2": "is temporarily unavailable and will be removed from the product | are temporarily unavailable and will be removed from the product",
    "continuare_indirizzo": "Do you want to continue with this searched address?",
    "nessun_indirizzo_selezionato": "No address selected",
    "indirizzi_fuori_zona": "Out-of-zone addresses:",
    "no": "no",
    "yes": "yes",
    "azienda": "Company",
    "privato": "Personal",
    "error_cap": "We were unable to find the zip code, please try again with another address",
    "error_numero": "We were unable to find the house number, please try again with another address",
    "nessuna_fascia_disponibile": "No timeslots available",
    "nessun_metodo_selezionato": 'No payment method selected',
    "salva_carta": 'Save your credit card details for next orders',
    "aggiungi_carta": 'Add a credit card',
    "stato_pagamento": 'Payment status',
    "pagamento_attesa": 'Waiting for payment confirmation',
    "pagamento_pagato": 'Paid',
    "pagamento_fallito": 'Failed',
    "metodi_pagamento_title": 'Payment methods',
    "aggiungi_carta_title": 'Add credit card',
    "confirm_remove_metodo_pagamento": 'Are you sure you want to delete the payment method?',
    "gestisci_carte_salvate": "MANAGE SAVED CARDS",
    "scad": "Exp.",
    "attendi_attimo": "Wait a moment",
    "elaborazione_pagamento": "We are processing your payment",
    "nn_chiudere_browser": "do not close the browser window",
    "grazie": "Thanks",
    "spedizione_gratuita": "DELIVERY FREE",
    "coupon_spedizione_gratuita": "FREE DELIVERY COSTS",
    "dil": "DELIVERY ON THE SPOT",
    "delivery_description": "(at home)",
    "dil_description": "(delivery without address)",
    "sp_select": "SELECT A SERVICE POINT",
    "select": "Select",
    "qr_scan": "SCAN QR CODE",
    "qr_new_scan": "SCAN NEW QR CODE",
    "selected_table": "SELECTED TABLE",
    "inserisci_indirizzo": 'ENTER THE ADDRESS',
    "msg_nussun_ristorante": "The address entered is not served by any restaurant. Please enter a new address and try again.",
    "msg_inserisci_indirizzo": "Enter the delivery address to see the restaurants that carry out the service in your area.",
    "trovami": "Find me",
    "label_indirizzo_consegna": "DELIVERY ADDRESS",
    "label_indirizzo_salvato": "OR CHOOSE A SAVED ADDRESS",
    "sconti_non_applicabili": "Discounts not applicable",
    "variante_obbligatoria_alert": "Be careful, you have to make a choice for the field: {etichetta}",
    "min_aggiunte_necessarie_sing": "It’s necessary to enter at least {MIN_AGGIUNTE} addition of the group {GRUPPO}",
    "min_aggiunte_necessarie_plur": "It’s necessary to enter at least {MIN_AGGIUNTE} additions of the group {GRUPPO}",
    "racer_ready": "Ready for delivery",
    "racer_assigned": "Order assigned to rider",
    "racer_on_delivery": "Order on its way",
    "racer_delivered": "Delivered",
    "racer_undeliverable": "We were not able to deliver your order",
    "racer_cancelled": "Delivery has been cancelled",
    "attivo_solo_per": "Active only for",
    "coupon_non_utilizzabile": "This discount code cannot be used for this order",

    /* NUOVI TESTI 2026 */
    "feedback": "Feedback",
    "feedback_invia": "Send feedback",
    "feedback_intro_text": "Your opinion is very important to improve our service.",
    "feedback_intro_completed_text": "Thank you for the time you dedicated to us, your suggestions are always valuable and will help make our service better and better!",
    "feedback_non_disponibile": "Feedback not available",
    "feedback_no_questions": "No questions available",
    "feedback_domande_incomplete": "Please answer all questions before sending",
    "feedback_inviato_successo": "Thank you, your feedback has been sent!",
    "feedback_inviato_il": "Sent on",
    "feedback_ordine_numero": "Order no.:",
    "riordina": "Reorder",
    "order": "Order",
    "codici_sconto": "Discount codes",
    "fidelity": "Fidelity",
    "card": "Card",
    "invia_sondaggio": "Send survey",
    "sondaggio_completato": "Survey completed",
    "sondaggio_rispondi": "Answer the questions",
    "sondaggio_login_title": "Log in to fill in the survey",
    "sondaggio_login_description": "Please log in to answer the questions and receive any discount code.",
    "sondaggio_non_disponibile": "Survey not available",
    "sondaggio_completed_intro": "The survey has been completed!",
    "sondaggio_completed_coupon_available": "Here is your discount code:",
    "sondaggio_completed_coupon_hint": "You will also receive it by email (check your spam folder too), and you will also find it in the app's discount codes section.",
    "sondaggio_completed_coupon_used": "You have already used this discount code in an order.",
    "sondaggio_completed_thanks": "Thank you, your suggestions help us improve our service.",
    "inserisci_codice": "Enter the code",
    "inserisci_codice_oppure": "or click on one of the codes listed below",


}
